import { EnumHelper } from "@singularsystems/neo-core";

export enum InvestorTypes {
    Individual = 1,
    Minor = 2,
    Company = 3,
    Trust = 4,
    ClubAssociationStokvel = 5,
    ClosedCorporation = 6
}